
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M10.87 2.14c-.542.094.148 2.114 0 3.238-.099.75-.389 1.87-.87 3.363h.87v4.523l2.609-.928V18h4.545V3.88c-2.232-1.596-4.616-2.176-7.154-1.74zM6.698 2.14c.542.094-.149 2.114 0 3.238.098.75.388 1.87.87 3.363h-.87v4.523l-2.61-.928V18L0 18.12V4c1.927-1.676 4.16-2.296 6.698-1.86z","fill":"#4A90E2"}}),_c('path',{attrs:{"fill":"#FFF","d":"M7 10.5L6 10l.25 1H7zM11 10.5h2l-.5 1H11z"}})])])
          )
        }
      }
    